var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramLightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 0H9.5C4.27546 0 0 4.27361 0 9.5V28.5C0 33.7245 4.27546 38 9.5 38H28.5C33.7245 38 38 33.7245 38 28.5V9.5C38 4.27361 33.7245 0 28.5 0ZM19 26.9164C14.6271 26.9164 11.0832 23.3709 11.0832 19C11.0832 14.6271 14.6271 11.0832 19 11.0832C23.3709 11.0832 26.9168 14.6271 26.9168 19C26.9168 23.3709 23.3709 26.9164 19 26.9164ZM29.2918 11.0832C27.9789 11.0832 26.9168 10.0196 26.9168 8.70818C26.9168 7.39673 27.9789 6.33318 29.2918 6.33318C30.6047 6.33318 31.6668 7.39673 31.6668 8.70818C31.6668 10.0196 30.6047 11.0832 29.2918 11.0832Z",
    fill: "#FFFFF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLightIcon);
export default __webpack_public_path__ + "static/media/instagram-light-icon.7b1ec3667e5a3908858ff763c2488f47.svg";
export { ForwardRef as ReactComponent };